// @ts-nocheck
import React, { useCallback, useEffect, useState } from "react";
import styled from "styled-components";
import SmartSelector from "./SmartSelector";
import { defineMessages, FormattedMessage } from "react-intl";
import globalMessages from "../../intl/globalMessages";

const messages = defineMessages({
  ...globalMessages,
});

const Title = styled.div`
  font: ${({ theme }) => theme.sixteenBold};
  display: flex;
  align-items: center;
`;
const Arrow = styled.span`
  margin-left: 5px;
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  ${props => (props.expanded ? " border-bottom: 5px solid black" : "border-top: 5px solid black")};
  border-bottom-color: ${({ theme }) => theme.regularTextColor};
  border-top-color: ${({ theme }) => theme.regularTextColor};
`;
const Collapse = styled.div`
  &:first-child {
    border-top: 0;
  }
  border-top: 1px solid ${({ theme }) => theme.buttonLightBorder};
  padding: 20px 0 20px 0;
  cursor: pointer;
`;

const StyledSmartSelector = styled(SmartSelector)`
  margin-left: -5px;
`;

const CheckAllControlFilter = styled.div`
    margin-top: -20px;
    color: #87cefa;
    cursor: default;
    & *:first-child {
        cursor: pointer;
    }
    & *:nth-child(2) {
        margin-left: 5px;
        cursor: pointer;
    }
    & *:nth-child(3) {
        margin-left: 5px;
        cursor: pointer;
    }
    & *:nth-child(4) {
        margin-left: 5px;
        cursor: pointer;
    }
    & *:last-child {
        margin-left: 5px;
        cursor: pointer;
    }
`;

function SmartSelectorList({ value, field, onChange, formValues, ...props }) {
  const [expanded, setExpanded] = useState([]);
  const [values, setValues] = useState(value);

  useEffect((prevValue) => {
    if (prevValue?.current !== value) {
      setValues(value);
    }
  }, [value]);

  useEffect(() => {
    if (!expanded.length && formValues[field.fieldName]) {
      setExpanded(
        field &&
          Array.isArray(field.propertyTickers) &&
          field.propertyTickers.map((it, idx) => false)
      );
    }
  }, [expanded, field, formValues]);

  const toggle = useCallback(index => {
    setExpanded(prevExpanded =>
      prevExpanded.map((it, idx) => {
        if (idx === index) {
          it = !it;
        }
        return it;
      })
    );
  }, []);
  const handleOnChange = useCallback(
    ({ value, field, index }) => {
      if (Array.isArray(values) && index !== undefined) {
        const newValues = [...values];
        newValues[index] = value;
        setValues(newValues);
        onChange({ value: newValues, field });
      }
    },
    [onChange, values]
  );

  const handleAllFiltersSelect = useCallback(() => {
    const value =
      Array.isArray(field?.options) &&
      field?.options.map(option => Array.isArray(option) && option.map(it => it.ticker));
    setValues(value);
    onChange({ value, field: field?.fieldName });
  }, [field, onChange]);

  const handleAllFiltersDeselect = useCallback(() => {
    const value = Array.isArray(field?.options) && field?.options.map(option => []);
    setValues(value);
    onChange({ value, field: field?.fieldName });
  }, [field, onChange]);

  return (
    <>
      <CheckAllControlFilter>
        <span onClick={handleAllFiltersSelect}>
          <FormattedMessage {...messages.selectAll} />
        </span>
        <span>{" | "}</span>
        <span onClick={handleAllFiltersDeselect}>
          {" "}
          <FormattedMessage {...messages.selectNone} />
        </span>
        <span>{" | "}</span>
        <span onClick={field.onEditByExcel}>
            {" "}
          <FormattedMessage {...messages.editByExcel} />
        </span>
      </CheckAllControlFilter>
      {field.propertyTickers.map((propertyTicker: string, index: number) => {
        const options = field.options[index] || [];
        return (
          <Collapse key={index}>
            <Title onClick={() => toggle(index)}>
              <span>{propertyTicker}</span>
              <Arrow expanded={expanded[index]} />
            </Title>
            {expanded[index] && (
              <StyledSmartSelector
                {...props}
                field={{ ...field, options }}
                value={values[index]}
                parentIndex={index}
                onChange={obj => handleOnChange(obj)}
              />
            )}
          </Collapse>
        );
      })}
    </>
  );
}

export default SmartSelectorList;
